import { NotificationType } from '@shared/types/notification.types';
import { addDoc, collection, doc, getDoc, Timestamp } from 'firebase/firestore';
import { db } from '../../../config/firebase';
import { NOTIFICATION_TEMPLATES } from '../constants/notificationTemplates';

interface CreateNotificationParams {
  receiverId: string;
  type: NotificationType;
  metadata?: Record<string, any>;
}

export const useNotifications = () => {
  const createNotification = async ({
    receiverId,
    type,
    metadata = {},
  }: CreateNotificationParams) => {
    try {
      const template = NOTIFICATION_TEMPLATES[type];

      if (!template) {
        throw new Error(`No template found for notification type: ${type}`);
      }

      // Get sender's name if available
      let senderName = 'Someone';
      if (metadata.actorId) {
        const senderDoc = await getDoc(doc(db, 'users', metadata.actorId));
        if (senderDoc.exists()) {
          const senderData = senderDoc.data();
          senderName = senderData.name || senderData.username || 'Someone';
        }
      }

      const notification = {
        userId: receiverId,
        type,
        title: template.title,
        message: template.message,
        priority: template.priority,
        data: {
          ...metadata,
          actorId: metadata.actorId,
        },
        read: false,
        createdAt: Timestamp.now(),
      };

      await addDoc(collection(db, 'notifications'), notification);
    } catch (error) {
      console.error('Error creating notification:', error);
      throw error;
    }
  };

  return {
    createNotification,
  };
};
